import { Form, Modal, Typography } from "antd"
import React, { useState } from "react"

import { SubcontractorForm } from "./SubcontractorForm.tsx"
import type { SubcontractorFormData } from "./subcontractor-form-data.ts"

const { Title } = Typography

interface SubcontractorFormProps {
  loading?: boolean
  initialValues?: Partial<SubcontractorFormData>
  onSave: (data: SubcontractorFormData) => Promise<void> | void
  onCancel: () => void
}

export const SubcontractorFormModal = ({
  initialValues,
  loading,
  onSave,
  onCancel
}: SubcontractorFormProps) => {
  const [saving, setSaving] = useState(false)
  const [form] = Form.useForm()

  const sendInvitation = Form.useWatch("send_invitation", form)

  const onSubmitHandler = async (data: SubcontractorFormData) => {
    const result = onSave(data)

    if (result instanceof Promise) {
      try {
        setSaving(true)
        await result
      } finally {
        setSaving(false)
      }
    }
  }

  return (
    <Modal
      open
      onCancel={onCancel}
      footer={null}
      width={800}
      title={
        <Title level={3} style={{ textAlign: "left" }}>
          {initialValues
            ? "Edit Subcontractor"
            : sendInvitation
              ? "Invite Subcontractor"
              : "Add Subcontractor"}
        </Title>
      }
      maskClosable={false}
      centered={true}
    >
      <SubcontractorForm
        innerForm={form}
        loading={loading || saving}
        onSave={onSubmitHandler}
        onCancel={onCancel}
        initialValues={initialValues}
      />
    </Modal>
  )
}
